export enum PublicationTaskStatus {
    ReadyToHandle = 0,
    InProgress = 1,
    Failed = 2,
    Canceled = 3,
    Published = 4,
    ProcessingPaused = 5,
    Translated = 6,
}
